export const INTERVENTION_STATUS = {
  nouvelle_demande: { label: 'Nouvelle demande', color: 'bg-blue-100 text-blue-700' },
  a_qualifier: { label: 'À qualifier', color: 'bg-indigo-100 text-indigo-700' },
  a_planifier: { label: 'À planifier', color: 'bg-purple-100 text-purple-700' },
  planifiee: { label: 'Planifiée', color: 'bg-cyan-100 text-cyan-700' },
  technicien_affecte: { label: 'Technicien affecté', color: 'bg-teal-100 text-teal-700' },
  recue: { label: 'Reçue', color: 'bg-sky-100 text-sky-700' },
  acceptee: { label: 'Acceptée', color: 'bg-emerald-100 text-emerald-700' },
  en_route: { label: 'En route', color: 'bg-amber-100 text-amber-700' },
  arrive: { label: 'Arrivé sur place', color: 'bg-amber-100 text-amber-700' },
  en_cours: { label: 'En cours', color: 'bg-yellow-100 text-yellow-700' },
  terminee: { label: 'Terminée', color: 'bg-green-100 text-green-700' },
  impossible: { label: 'Impossible', color: 'bg-red-100 text-red-700' },
  client_absent: { label: 'Client absent', color: 'bg-orange-100 text-orange-700' },
  materiel_a_prevoir: { label: 'Matériel à prévoir', color: 'bg-pink-100 text-pink-700' },
  en_attente_client: { label: 'En attente client', color: 'bg-gray-100 text-gray-700' },
  cloturee: { label: 'Clôturée', color: 'bg-green-100 text-green-800' },
  annulee: { label: 'Annulée', color: 'bg-neutral-200 text-neutral-600' },
};

export const INTERVENTION_TYPES = {
  depannage: 'Dépannage',
  programmee: 'Intervention programmée',
  visite_technique: 'Visite technique',
  controle: 'Contrôle',
  maintenance: 'Maintenance',
  urgence: 'Urgence',
  autre: 'Autre',
};

export const URGENCY_LEVELS = {
  faible: { label: 'Faible', color: 'bg-neutral-100 text-neutral-600' },
  normale: { label: 'Normale', color: 'bg-blue-100 text-blue-700' },
  haute: { label: 'Haute', color: 'bg-orange-100 text-orange-700' },
  critique: { label: 'Critique', color: 'bg-red-100 text-red-700' },
};

export const CLIENT_TYPES = {
  particulier: 'Particulier',
  professionnel: 'Professionnel',
  agence: 'Agence',
  autre: 'Autre',
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};
